import NursingPortalLayout from './NursingPortalLayout';

export default function NurseLayout() {
  return <NursingPortalLayout variant="nurse" />;
}
